/**
 * Global constants shared across all components.
 */
export class GlobalConstants {

	/**
	 * An empty guid identifier string.
	 */
	public static readonly EMPTY_GUID: string = "00000000-0000-0000-0000-000000000000";
	
	/**
	 * The default map view filter name.
	 */
	public static readonly DEFAULT_NO_VIEW_SELECTED_NAME: string = 'No View Selected';

	/**
	 * The tag number name.
	 */
	public static readonly TAG_NUMBER: string = 'Tag #'

	/**
	* The hawb name.
	*/
	public static readonly HAWB = 'HAWB'

	/**
	 * The mawb name.
	 */
	public static readonly MAWB = 'MAWB'

	/**
	 * The IT/TE number name.
	 */
	public static readonly IT_TE_NUMBER = 'IT/TE #'

	/**
	 * A regular expression for matching parseable phone numbers.
	 * Example patterns:
	 * 1234567890
	 * 123-456-7890
	 * (123) 456-7890
	 * 123 456 7890
	 * 123.456.7890
	 * +91 (123) 456-7890
	 */
	public static readonly PHONE_REGEX: RegExp = /^(\+\d{1,2}\s)?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;

	/**
	 * The types for internal reference numbers.
	 */
	public static readonly INTERNAL_REFERENCE_NUMBER_TYPES: string[] = [
		this.TAG_NUMBER,
		this.HAWB,
		this.MAWB,
		this.IT_TE_NUMBER
	];

	/** The number of milliseconds in a day. */
	public static readonly MILLISECONDS_IN_A_DAY: number = 86400000;

	/** The number of milliseconds in a minute. */
	public static readonly MILLISECONDS_IN_A_MINUTE: number = 60000;

	/** The number of milliseconds in 30 seconds or half a minute. */
	public  static readonly MILLISECONDS_IN_THIRTY_SECONDS: number = 30000;
}